// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1p-d4","col":"Table_col__3205L","fulfillmentStatus":"Table_fulfillmentStatus__2FV99","emailCol":"Table_emailCol__wy4ga"};